import React, { useRef } from 'react';
import './_files.table.scss'
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { Button } from 'react-bootstrap';
import FilePreview from './FilePreview';
import FileUrl from './FileUrl';
import { useTbodyPosition } from '../../../../../../utils/hooks/useTbodyPosition';

const Body = ({ isLoading, items, config, onDeleteFile }) => {
  const bodyRef = useRef(null);
  const position = useTbodyPosition({ bodyRef, count: items?.length, bodyHeight: '300px' });

  return (
    <tbody
      className={classNames('', { 'tbody-loading': isLoading })}
      style={{ backgroundPositionY: position.y, backgroundPositionX: '54%' }}
      ref={bodyRef}
    >
      {items.map((file) => (
        <tr
          key={`file-${file.id}`}
        >
          <td className="files-table__preview">
            <FilePreview name={file.name} url={file.preview_url || file.url} />
          </td>
          <td className="files-table__name">
            <a href={file.url} target="_blank" rel="noreferrer">{file.name}</a>
          </td>
          <td className="files-table__url">
            <FileUrl url={file.url} />
          </td>
          <td className="files-table__size">{file.size}</td>
          <td className="p-r files-table__action text-right">
            {config?.access?.files_delete ? (
              <Button
                onClick={(e) => onDeleteFile(e, file)}
                disabled={!file?.access?.delete}
                bsSize="xsmall"
              >
                Delete
              </Button>
            ) : null}
          </td>
        </tr>
      ))}
    </tbody>
  );
};

Body.propTypes = {
  isLoading: PropTypes.bool,
  items: PropTypes.array,
  config: PropTypes.object,
  onDeleteFile: PropTypes.func,
};

export default Body;
